export const BD_GET_MATERIALSTANDARD_LISTING = "BD_GET_MATERIALSTANDARD_LISTING"
export const BD_GET_MATERIALSTANDARD_LISTING_SUCCESS = "BD_GET_MATERIALSTANDARD_LISTING_SUCCESS"
export const BD_GET_MATERIALSTANDARD_LISTING_FAILED = "BD_GET_MATERIALSTANDARD_LISTING_FAILED"